// import { FullStory } from '@fullstory/browser';
// Utility function to sync Pardot tracking cookies
export const syncPardotTracking = (formData) => {
    try {
        // Generate unique IDs to ensure we remove the right elements
        const uniqueId = `pardot_${Date.now()}_${Math.random().toString(36).substring(2, 11)}`;
        const formId = `${uniqueId}_form`;
        const iframeId = `${uniqueId}_iframe`;

        // Create hidden iframe with unique ID
        const iframe = document.createElement('iframe');
        iframe.id = iframeId;
        iframe.name = iframeId;
        iframe.style.cssText = 'display: none; width: 0; height: 0; border: 0;';
        iframe.setAttribute('aria-hidden', 'true');
        document.body.appendChild(iframe);

        // Create form with unique ID
        const form = document.createElement('form');
        form.id = formId;
        form.method = 'POST';
        form.action = process.env.GATSBY_PARDOT_TRACKING_HANDLER;
        form.target = iframeId; // Target the iframe we just created
        form.style.display = 'none';

        // Get user agent safely (check if navigator is available for SSR compatibility)
        const getUserAgent = () => {
            if (typeof navigator !== 'undefined' && navigator.userAgent) {
                return navigator.userAgent;
            }
            return 'Unknown';
        };

        // Required Pardot Form Handler Fields
        const fields = {
            first_name: formData.first_name || '',
            last_name: formData.last_name || formData.email,
            email: formData.email || '',
            '00N1L00000F9eBV': formData.location,
            oid: process.env.GATSBY_OID,
            user_agent: getUserAgent(),
        };

        Object.keys(fields).forEach((key) => {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = fields[key];
            form.appendChild(input);
        });

        document.body.appendChild(form);
        form.submit();

        // Clean up after 3 seconds - remove by specific IDs
        setTimeout(() => {
            const formElement = document.getElementById(formId);
            const iframeElement = document.getElementById(iframeId);

            if (formElement && formElement.parentNode) {
                formElement.parentNode.removeChild(formElement);
            }
            if (iframeElement && iframeElement.parentNode) {
                iframeElement.parentNode.removeChild(iframeElement);
            }
        }, 3000);
    } catch (error) {
        console.error('Pardot tracking sync error:', error);
        // Don't throw - we don't want tracking errors to break the main flow
        // FullStory Event Tracking
        // FullStory('trackEvent', {
        //     name: 'Pardot Tracking Sync - Error',
        //     properties: {
        //         name: 'pardot_tracking',
        //         user_email: formData.email,
        //     },
        // });
    }
};
